import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { ClickViewingTypeCode } from 'app/viewing/_entities/click/model/types';

export type GetViewingTypeInfoRes = {
  [K in ClickViewingTypeCode]: {
    dailyLimit: number | null;
    point: number;
  };
};

export const getViewingTypeInfo = async (): Promise<GetViewingTypeInfoRes> => {
  const { data: response } = await serviceApi.viewing.getViewingType(withServiceRequestDefaults());
  return response.data.reduce<GetViewingTypeInfoRes>((acc, cur) => {
    acc[cur.typeCode] = {
      dailyLimit: cur.dailyLimitCount ?? null,
      point: cur.rewardPoint,
    };
    return acc;
  }, {} as GetViewingTypeInfoRes);
};
